import { Component, OnInit } from '@angular/core';

import { NotificationService } from '../../shared/notification.service';
import { Router } from '@angular/router';
import { Substatus } from '../substatus';
import { SubstatusService } from '../substatus.service';

@Component({
  selector: 'app-substatus-create',
  templateUrl: 'create.component.html',
})
export class SubstatusCreateComponent implements OnInit {
  /**
   * Details of the substatus being created.
   */
  public substatus: Substatus;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {SubstatusService} substatusService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private substatusService: SubstatusService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.substatusService.loading.subscribe(
      (result) => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank substatus if required.
   */
  public ngOnInit(): void {
    if (!this.substatus) {
      this.substatus = new Substatus();
    }
  }

  /**
   * Perform the create action which adds the new substatus into the backend.
   */
  public create() {
    const createSubstatus = this.substatusService
      .createSubstatus(this.substatus)
      .subscribe(
        (result: Substatus) => {
          this.notificationService.success(
            `Substatus Created`,
            `New substatus ${result.name} has been created with ID of ${result.id}.`,
            5,
          );
          this.substatus = new Substatus();
          createSubstatus.unsubscribe();
          this.router.navigate(['/substatuses']);
        },
        (err) => {
          this.notificationService.error(
            `Could not create Substatus`,
            err.error.message,
            10,
          );
        },
      );
  }
}
